exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".execution-cancellation-reason-text {\n  white-space: pre-wrap;\n}\n", ""]);

